import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate  } from 'react-router-dom';
import { useAuth } from '../src/components/AuthContext.tsx';
import Header from './components/Header.tsx';
import LoginPage from './components/LoginPage.tsx';
import SignUp from "./components/SignUp.tsx";
import HomePage from './components/HomePage.tsx';
import DashboardPage from './components/DashboardPage.tsx';
import LicensePage from './components/LicensePage.tsx';
import NotFound from './components/NotFound.tsx'
import Users from './components/Users.tsx';
import Unauthorized from './components/Unauthorized.tsx'
import './index.scss';


const App: React.FC = () => {
  const { isAuthenticated } = useAuth();
  

  return (
    <Router>            
      <Header isAuthenticated={isAuthenticated} />
      <Routes>
        <Route path="/login" element={!isAuthenticated ? <LoginPage /> :  <Navigate to="/home" />} />
        <Route path="/sign-up" element={!isAuthenticated ? <SignUp /> :  <Navigate to="/home" />} />
        <Route path="/home" element={isAuthenticated ? <HomePage /> : <Navigate to="/login" />} />
        <Route path="/dashboard" element={isAuthenticated ? <DashboardPage /> : <Navigate to="/login" />} />
        <Route path="/licenses" element={isAuthenticated ? <LicensePage /> : <Navigate to="/login" />} />
        <Route path="/users" element={isAuthenticated ? <Users /> : <Navigate to="/login" />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/unauthorized-access" element={<Unauthorized />} /> 
        <Route path="*" element={<NotFound />} /> 
      </Routes>
    </Router>
  );
};

export default App;
